import React, { FC } from 'react'
import { Specialized } from 'components/atoms/icons'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { Typography } from 'transfix-ui/core'
import { ReeferIcon, DryVanIcon, DropTrailerIcon, FlatBedIcon } from 'transfix-icons'
import { Tooltip } from 'transfix-ui'

const ICON_TYPES = {
  dry_van: DryVanIcon,
  reefer: ReeferIcon,
  open_deck: FlatBedIcon,
  specialized: Specialized,
  drop_trailer: DropTrailerIcon,
}

interface IEquipmentIconProps {
  className?: string
  icon?: keyof typeof ICON_TYPES | string | null
  tooltip?: string
}

const EquipmentIcon: FC<IEquipmentIconProps> = ({ className, icon, tooltip }) => {
  let Component: FC<ICommonProps> | null | undefined = null

  if (icon) {
    Component = ICON_TYPES[icon as keyof typeof ICON_TYPES]
  }

  if (!Component) {
    return null
  }

  return (
    <Tooltip
      position='bottom'
      id={icon || ''}
      trigger={
        <span>
          <Component className={className} />
        </span>
      }>
      <Typography variant='body2'>{tooltip}</Typography>
    </Tooltip>
  )
}

export default EquipmentIcon
